var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVector4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "aboutPeople_x5F_SVG",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    enableBackground: "new 0 0 17 17",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BB",
    d: "M7.756,8.053H3.69L3.652,8.034L3.109,7.371L3.098,7.34V6.557l0.027-0.044L5.1,5.46l0.023-0.006H6.33 l0.025,0.007l1.816,1.053l0.025,0.043V7.42L8.188,7.448L7.797,8.03L7.756,8.053z M3.715,7.952h4.014l0.369-0.547V6.586 L6.316,5.555H5.135L3.198,6.587v0.734L3.715,7.952z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BB",
    d: "M5.231,5.546L5.197,5.533L4.538,4.938L4.521,4.901V3.495L4.536,3.46l0.579-0.583L5.15,2.862h1.248 l0.035,0.015l0.508,0.508l0.014,0.036v1.44L6.939,4.897L6.262,5.521L6.229,5.535L5.231,5.546L5.231,5.546z M4.621,4.879 L5.25,5.445l0.959-0.01l0.646-0.597V3.441L6.378,2.963H5.172L4.621,3.517V4.879z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BB",
    d: "M7.756,8.053L7.748,8.052L4.715,7.615L3.711,8.049h-0.04L3.644,8.02L3.422,7.43L3.141,7.389L3.1,7.35 l0.023-0.053l0.203-0.123l-0.225-0.6l0.008-0.049l0.047-0.018l0.992,0.171L5.55,5.834L5.096,5.547L5.078,5.482l0.061-0.025 l0.048,0.017l0.245-0.542L4.541,4.244L4.522,4.196l0.033-0.039L5.228,3.93L4.547,3.539L4.521,3.49l0.035-0.042l1.826-0.583 l0.053,0.014l0.009,0.055L6.131,3.628L6.89,3.373l0.058,0.019l-0.004,0.06L6.201,4.374L6.93,4.793l0.019,0.068L6.881,4.88 L6.137,4.452L5.69,5.006l0.568,0.439l0.02,0.042l-0.024,0.04L5.92,5.729l1.615,0.563l0.06-0.025L7.641,6.27l0.023,0.038 l0.003,0.029L8.164,6.51l0.03,0.063L8.131,6.604L7.676,6.446L7.73,7.098l0.443,0.28l0.02,0.061L8.139,7.47L7.756,7.403l0.05,0.595 L7.79,8.039L7.756,8.053z M4.891,7.54l2.811,0.404L7.654,7.386L5.937,7.09L4.891,7.54z M3.535,7.445l0.184,0.49l0.807-0.348 L3.535,7.445z M3.494,7.339l1.207,0.174l1.055-0.454L4.168,6.784L3.449,7.217L3.494,7.339z M7.747,7.301l0.161,0.027L7.74,7.223 L7.747,7.301z M3.294,7.31l0.088,0.013L3.361,7.27L3.294,7.31z M6.104,7.017l1.541,0.267l-0.01-0.129L6.886,6.681L6.104,7.017z  M3.226,6.621l0.188,0.5l0.604-0.363L3.226,6.621z M6.996,6.633L7.625,7.03L7.572,6.41L7.539,6.398L6.996,6.633z M4.299,6.705 l1.625,0.28l0.859-0.37l-1.138-0.72L4.299,6.705z M5.74,5.837l1.154,0.73L7.4,6.35L5.809,5.796L5.74,5.837z M5.516,5.694 l0.131,0.083l0.039-0.024L5.516,5.694z M5.285,5.508l0.512,0.179L6.14,5.479L5.628,5.084L5.285,5.508z M5.513,4.995L5.438,5.16 l0.111-0.138L5.513,4.995z M5.555,4.901l0.057,0.044L6.05,4.402L5.836,4.279L5.555,4.901z M4.676,4.223l0.798,0.615L5.748,4.23 L5.346,3.997L4.676,4.223z M5.877,4.188l0.236,0.136l0.646-0.801l-0.685,0.23L5.877,4.188z M5.472,3.955L5.79,4.138l0.155-0.342 L5.472,3.955z M4.695,3.509l0.66,0.38l0.646-0.217l0.306-0.678L4.695,3.509z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BB",
    d: "M13.547,8.053H9.48L9.443,8.034L8.9,7.371L8.89,7.34V6.557l0.026-0.044l1.975-1.053l0.023-0.006h1.207 l0.025,0.007l1.815,1.053l0.024,0.043V7.42l-0.008,0.028L13.588,8.03L13.547,8.053z M9.506,7.952h4.014l0.369-0.547V6.586 l-1.781-1.031h-1.182L8.989,6.587v0.734L9.506,7.952z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BB",
    d: "M11.023,5.546l-0.035-0.013L10.33,4.938l-0.018-0.037V3.495l0.016-0.035l0.578-0.583l0.035-0.015h1.248 l0.035,0.015l0.508,0.508l0.014,0.036v1.44L12.73,4.897l-0.679,0.624L12.02,5.535L11.023,5.546L11.023,5.546z M10.413,4.879 l0.628,0.566L12,5.436l0.646-0.597V3.441L12.17,2.963h-1.207l-0.55,0.554V4.879z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BB",
    d: "M13.547,8.053l-0.008-0.001l-3.033-0.437L9.502,8.049h-0.04L9.436,8.02L9.213,7.43L8.932,7.389L8.891,7.35 l0.023-0.053l0.203-0.123l-0.225-0.6L8.9,6.525l0.047-0.018l0.993,0.171l1.401-0.844l-0.454-0.288l-0.019-0.064l0.062-0.025 l0.047,0.017l0.246-0.542l-0.892-0.688l-0.019-0.048l0.033-0.039L11.02,3.93l-0.684-0.392L10.313,3.49l0.035-0.042l1.826-0.583 l0.053,0.014l0.008,0.055l-0.313,0.694l0.76-0.255l0.057,0.019l-0.002,0.061l-0.743,0.922l0.729,0.419l0.019,0.068L12.672,4.88 l-0.744-0.428l-0.445,0.554l0.568,0.439l0.02,0.042l-0.024,0.04l-0.334,0.201l1.616,0.563l0.059-0.025l0.047,0.004l0.022,0.038 l0.003,0.029l0.497,0.173l0.03,0.063l-0.063,0.031l-0.455-0.158l0.056,0.65l0.442,0.281l0.021,0.061L13.93,7.47l-0.383-0.066 l0.051,0.595L13.581,8.04L13.547,8.053z M10.682,7.54l2.812,0.404l-0.048-0.559l-1.717-0.297L10.682,7.54z M9.326,7.445 l0.184,0.49l0.807-0.348L9.326,7.445z M9.286,7.339l1.206,0.174l1.055-0.454L9.959,6.784L9.24,7.217L9.286,7.339z M13.539,7.301 l0.16,0.027l-0.168-0.106L13.539,7.301z M9.086,7.31l0.087,0.013L9.152,7.27L9.086,7.31z M11.896,7.017l1.541,0.267l-0.012-0.128 l-0.749-0.475L11.896,7.017z M9.018,6.621l0.188,0.5l0.604-0.363L9.018,6.621z M12.788,6.633l0.628,0.397l-0.053-0.62L13.33,6.398 L12.788,6.633z M10.09,6.705l1.625,0.28l0.859-0.37l-1.139-0.721L10.09,6.705z M11.531,5.837l1.154,0.73l0.506-0.218L11.6,5.796 L11.531,5.837z M11.307,5.694l0.131,0.083l0.039-0.024L11.307,5.694z M11.076,5.508l0.512,0.179l0.344-0.207l-0.513-0.396 L11.076,5.508z M11.305,4.995L11.229,5.16l0.11-0.138L11.305,4.995z M11.346,4.901l0.057,0.044l0.438-0.543l-0.213-0.123 L11.346,4.901z M10.468,4.223l0.798,0.615L11.54,4.23l-0.403-0.232L10.468,4.223z M11.668,4.188l0.236,0.136l0.646-0.801 l-0.687,0.23L11.668,4.188z M11.264,3.955l0.318,0.183l0.154-0.342L11.264,3.955z M10.486,3.509l0.66,0.38l0.646-0.217 l0.306-0.678L10.486,3.509z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BB",
    d: "M16.436,14.021h-4.063l-0.039-0.021l-0.542-0.662l-0.012-0.03v-0.783l0.025-0.045l1.975-1.054l0.023-0.006 h1.209l0.023,0.009l1.816,1.053l0.024,0.043v0.863l-0.008,0.026l-0.392,0.582L16.436,14.021z M12.395,13.919h4.016l0.367-0.547 v-0.817l-1.779-1.031h-1.182l-1.938,1.031v0.733L12.395,13.919z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BB",
    d: "M13.912,11.514l-0.033-0.013l-0.66-0.596l-0.017-0.037V9.463l0.015-0.037l0.579-0.582l0.035-0.015h1.248 l0.034,0.015l0.508,0.508l0.016,0.034v1.44l-0.018,0.037l-0.678,0.625l-0.032,0.014L13.912,11.514L13.912,11.514z M13.303,10.848 l0.629,0.565l0.957-0.011l0.647-0.598V9.408L15.059,8.93h-1.207l-0.549,0.552V10.848L13.303,10.848z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BB",
    d: "M16.436,14.021L16.43,14.02l-3.033-0.437l-1.006,0.435h-0.039l-0.026-0.029l-0.224-0.59l-0.279-0.041 l-0.043-0.039l0.023-0.053l0.203-0.123l-0.225-0.601l0.009-0.049l0.047-0.019l0.991,0.17l1.402-0.844l-0.455-0.287l-0.019-0.063 l0.062-0.025l0.049,0.017l0.244-0.541l-0.891-0.688l-0.019-0.049l0.032-0.039l0.675-0.228l-0.685-0.391l-0.022-0.049l0.032-0.043 l1.828-0.582l0.053,0.014l0.009,0.055l-0.313,0.693l0.76-0.254l0.057,0.02l-0.002,0.06l-0.744,0.922l0.73,0.42l0.018,0.068 l-0.068,0.019l-0.742-0.429l-0.446,0.556l0.567,0.438l0.021,0.041l-0.024,0.041l-0.336,0.2l1.617,0.563l0.059-0.024l0.045,0.004 l0.025,0.037l0.002,0.029l0.496,0.174l0.031,0.063l-0.064,0.031l-0.455-0.158l0.056,0.65l0.442,0.28l0.021,0.062l-0.057,0.031 l-0.383-0.066l0.051,0.596l-0.016,0.041L16.436,14.021z M13.57,13.507l2.811,0.404l-0.047-0.56l-1.717-0.297L13.57,13.507z  M12.215,13.413l0.184,0.489l0.809-0.348L12.215,13.413z M12.176,13.307l1.206,0.174l1.054-0.453l-1.588-0.275l-0.719,0.434 L12.176,13.307z M16.428,13.27l0.161,0.026l-0.168-0.106L16.428,13.27z M11.975,13.275l0.088,0.015l-0.021-0.054L11.975,13.275z  M14.785,12.982l1.541,0.269l-0.012-0.129l-0.748-0.476L14.785,12.982z M11.906,12.589l0.188,0.5l0.604-0.362L11.906,12.589z  M15.678,12.602l0.627,0.396l-0.052-0.619l-0.032-0.012L15.678,12.602z M12.979,12.673l1.627,0.279l0.857-0.369l-1.138-0.722 L12.979,12.673z M14.421,11.805l1.153,0.729l0.506-0.218l-1.592-0.555L14.421,11.805z M14.195,11.661l0.131,0.084l0.039-0.025 L14.195,11.661z M13.966,11.477l0.513,0.178l0.342-0.207l-0.512-0.396L13.966,11.477z M14.193,10.962l-0.074,0.166l0.109-0.139 L14.193,10.962z M14.234,10.868l0.058,0.045l0.438-0.543l-0.213-0.123L14.234,10.868z M13.357,10.189l0.797,0.617l0.275-0.611 l-0.404-0.231L13.357,10.189z M14.559,10.155l0.234,0.135l0.646-0.801l-0.686,0.229L14.559,10.155z M14.152,9.922l0.318,0.182 l0.153-0.342L14.152,9.922z M13.375,9.475l0.661,0.381l0.646-0.217l0.307-0.677L13.375,9.475z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BB",
    d: "M10.645,14.021H6.58l-0.039-0.021l-0.543-0.662l-0.011-0.03v-0.783l0.026-0.045l1.975-1.054l0.023-0.006 h1.207l0.025,0.009l1.815,1.053l0.025,0.043v0.863l-0.008,0.026l-0.393,0.582L10.645,14.021z M6.604,13.919h4.015l0.367-0.547 v-0.817l-1.779-1.031H8.024l-1.937,1.031v0.733L6.604,13.919z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BB",
    d: "M8.121,11.514l-0.034-0.013l-0.659-0.596l-0.017-0.037V9.463l0.015-0.037l0.578-0.582L8.04,8.83h1.248 l0.035,0.015L9.83,9.352l0.016,0.035v1.44l-0.018,0.037L9.15,11.489l-0.032,0.014L8.121,11.514L8.121,11.514z M7.511,10.848 l0.629,0.565l0.958-0.011l0.646-0.598V9.408L9.268,8.931H8.061l-0.55,0.551V10.848z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BB",
    d: "M10.645,14.021l-0.006-0.002l-3.034-0.437L6.6,14.018H6.561l-0.027-0.029l-0.223-0.59l-0.28-0.041 l-0.042-0.039l0.023-0.053l0.203-0.123L5.99,12.542l0.009-0.049l0.047-0.019l0.991,0.17l1.402-0.844l-0.455-0.287L7.967,11.45 l0.062-0.025l0.048,0.017L8.321,10.9L7.43,10.211l-0.018-0.049l0.033-0.039l0.673-0.227L7.436,9.506L7.411,9.458l0.034-0.043 l1.827-0.582l0.054,0.014l0.009,0.055L9.02,9.594l0.76-0.254l0.058,0.02l-0.002,0.06L9.09,10.34l0.73,0.42l0.018,0.068 l-0.068,0.02l-0.742-0.429L8.58,10.975l0.568,0.438l0.02,0.041l-0.025,0.041l-0.333,0.2l1.616,0.563l0.06-0.024l0.045,0.004 l0.023,0.037l0.004,0.029l0.496,0.174l0.031,0.063l-0.064,0.031l-0.455-0.158l0.056,0.65l0.442,0.28l0.021,0.062l-0.057,0.031 l-0.383-0.066l0.051,0.596l-0.016,0.041L10.645,14.021z M7.78,13.507l2.81,0.404l-0.047-0.56l-1.718-0.295L7.78,13.507z  M6.424,13.413l0.184,0.489l0.808-0.348L6.424,13.413z M6.384,13.307l1.207,0.174l1.054-0.453l-1.588-0.275l-0.719,0.434 L6.384,13.307z M10.637,13.27l0.16,0.026l-0.167-0.106L10.637,13.27z M6.184,13.275l0.088,0.015l-0.021-0.054L6.184,13.275z  M8.994,12.982l1.541,0.269l-0.012-0.129l-0.75-0.476L8.994,12.982z M6.115,12.589l0.188,0.5l0.604-0.362L6.115,12.589z  M9.887,12.602l0.627,0.396l-0.053-0.619l-0.031-0.012L9.887,12.602z M7.188,12.673l1.625,0.279l0.859-0.369l-1.138-0.722 L7.188,12.673z M8.63,11.805l1.153,0.729l0.506-0.218l-1.592-0.555L8.63,11.805z M8.404,11.661l0.131,0.084l0.039-0.025 L8.404,11.661z M8.175,11.477l0.511,0.178l0.343-0.207l-0.511-0.396L8.175,11.477z M8.402,10.962l-0.075,0.166l0.11-0.139 L8.402,10.962z M8.444,10.868L8.5,10.913l0.438-0.543l-0.214-0.123L8.444,10.868z M7.565,10.189l0.798,0.617l0.275-0.611 L8.234,9.963L7.565,10.189z M8.767,10.155l0.235,0.135l0.646-0.801L8.962,9.719L8.767,10.155z M8.361,9.922l0.318,0.182 l0.154-0.342L8.361,9.922z M7.584,9.475l0.661,0.381l0.646-0.217l0.304-0.677L7.584,9.475z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BB",
    d: "M4.748,14.021H0.682l-0.041-0.023L0.25,13.415l-0.01-0.026v-0.863l0.025-0.043l1.816-1.053l0.025-0.009 h1.208l0.023,0.006l1.974,1.054l0.027,0.045v0.783l-0.012,0.03l-0.542,0.662L4.748,14.021z M0.709,13.919h4.015l0.517-0.631 v-0.733l-1.938-1.031H2.121l-1.78,1.031v0.817L0.709,13.919z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BB",
    d: "M3.207,11.514L3.207,11.514l-0.998-0.011l-0.033-0.014l-0.678-0.625l-0.016-0.037v-1.44l0.015-0.035 l0.507-0.507L2.039,8.83h1.248l0.035,0.015l0.58,0.582l0.014,0.037v1.405L3.9,10.905l-0.66,0.596L3.207,11.514z M2.229,11.402 l0.959,0.011l0.629-0.565V9.482L3.266,8.931H2.061L1.582,9.408v1.396L2.229,11.402z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BB",
    d: "M0.682,14.021l-0.033-0.015l-0.016-0.041l0.049-0.596l-0.383,0.065l-0.055-0.03l0.02-0.062l0.444-0.281 l0.054-0.649L0.307,12.57l-0.063-0.03l0.03-0.063l0.497-0.174l0.002-0.029l0.024-0.037l0.046-0.004l0.059,0.025l1.615-0.563 l-0.334-0.201l-0.023-0.04l0.019-0.041l0.568-0.438l-0.446-0.556l-0.744,0.429l-0.068-0.019l0.02-0.068l0.729-0.42L1.493,9.418 L1.491,9.357L1.549,9.34l0.759,0.254L1.994,8.901l0.008-0.055l0.053-0.014l1.826,0.582l0.035,0.043L3.891,9.506L3.209,9.896 l0.674,0.228l0.033,0.039l-0.02,0.049L3.006,10.9l0.245,0.541l0.047-0.017L3.36,11.45l-0.019,0.063l-0.455,0.287l1.402,0.844 l0.992-0.17l0.047,0.019l0.008,0.049L5.11,13.143l0.204,0.123l0.022,0.053l-0.041,0.039l-0.281,0.041l-0.221,0.59l-0.027,0.029 h-0.04l-1.005-0.435L0.688,14.02L0.682,14.021z M0.784,13.354l-0.047,0.559l2.81-0.404l-1.045-0.451L0.784,13.354z M3.912,13.557 l0.807,0.348l0.184-0.49L3.912,13.557z M2.682,13.025l1.055,0.453l1.207-0.174l0.045-0.121L4.27,12.751L2.682,13.025z  M0.697,13.188l-0.168,0.107l0.162-0.027L0.697,13.188z M5.076,13.236l-0.02,0.054l0.087-0.015L5.076,13.236z M0.803,13.122 l-0.01,0.129l1.541-0.269l-0.781-0.336L0.803,13.122z M4.421,12.727l0.604,0.362l0.188-0.5L4.421,12.727z M0.865,12.378 l-0.051,0.619l0.627-0.396l-0.543-0.234L0.865,12.378z M1.654,12.583l0.859,0.369l1.625-0.279l-1.346-0.812L1.654,12.583z  M1.038,12.316l0.505,0.218l1.154-0.729l-0.068-0.041L1.038,12.316z M2.752,11.72l0.039,0.025l0.131-0.084L2.752,11.72z  M2.298,11.445l0.343,0.207l0.512-0.178l-0.342-0.424L2.298,11.445z M2.889,10.989L3,11.128l-0.074-0.166L2.889,10.989z  M2.389,10.37l0.438,0.543l0.057-0.045l-0.281-0.622L2.389,10.37z M2.689,10.195l0.275,0.611l0.797-0.617L3.093,9.963 L2.689,10.195z M1.679,9.489l0.646,0.801l0.235-0.135L2.363,9.719L1.679,9.489z M2.493,9.762l0.154,0.342l0.319-0.182L2.493,9.762 z M2.438,9.639l0.645,0.217l0.66-0.381L2.131,8.962L2.438,9.639z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1C75BB",
    cx: 6.906,
    cy: 3.414,
    r: 0.168
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1C75BB",
    cx: 4.613,
    cy: 3.469,
    r: 0.168
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1C75BB",
    cx: 5.261,
    cy: 5.458,
    r: 0.168
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1C75BB",
    cx: 4.205,
    cy: 6.701,
    r: 0.168
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1C75BB",
    cx: 8.147,
    cy: 6.562,
    r: 0.168
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1C75BB",
    cx: 3.708,
    cy: 8.003,
    r: 0.168
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1C75BB",
    cx: 7.766,
    cy: 8.003,
    r: 0.168
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1C75BB",
    cx: 3.18,
    cy: 6.562,
    r: 0.168
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1C75BB",
    cx: 5.875,
    cy: 7.038,
    r: 0.168
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1C75BB",
    cx: 12.697,
    cy: 3.469,
    r: 0.168
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1C75BB",
    cx: 11.271,
    cy: 4.897,
    r: 0.169
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1C75BB",
    cx: 8.939,
    cy: 7.325,
    r: 0.168
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1C75BB",
    cx: 9.904,
    cy: 6.729,
    r: 0.169
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1C75BB",
    cx: 13.479,
    cy: 7.066,
    r: 0.169
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1C75BB",
    cx: 11.699,
    cy: 7.038,
    r: 0.168
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1C75BB",
    cx: 9.795,
    cy: 9.381,
    r: 0.168
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1C75BB",
    cx: 7.502,
    cy: 9.436,
    r: 0.168
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1C75BB",
    cx: 8.15,
    cy: 11.425,
    r: 0.168
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1C75BB",
    cx: 7.094,
    cy: 12.669,
    r: 0.168
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1C75BB",
    cx: 11.036,
    cy: 12.528,
    r: 0.169
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1C75BB",
    cx: 6.597,
    cy: 13.97,
    r: 0.168
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1C75BB",
    cx: 10.654,
    cy: 13.97,
    r: 0.169
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1C75BB",
    cx: 6.069,
    cy: 12.528,
    r: 0.169
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1C75BB",
    cx: 8.765,
    cy: 13.005,
    r: 0.169
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1C75BB",
    cx: 3.826,
    cy: 9.436,
    r: 0.168
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1C75BB",
    cx: 3.177,
    cy: 11.425,
    r: 0.169
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1C75BB",
    cx: 0.291,
    cy: 12.527,
    r: 0.168
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1C75BB",
    cx: 4.73,
    cy: 13.97,
    r: 0.168
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1C75BB",
    cx: 5.258,
    cy: 12.527,
    r: 0.168
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1C75BB",
    cx: 2.563,
    cy: 13.005,
    r: 0.168
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1C75BB",
    cx: 15.586,
    cy: 9.436,
    r: 0.168
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1C75BB",
    cx: 14.16,
    cy: 10.864,
    r: 0.168
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1C75BB",
    cx: 11.829,
    cy: 13.292,
    r: 0.168
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1C75BB",
    cx: 12.794,
    cy: 12.696,
    r: 0.168
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1C75BB",
    cx: 16.369,
    cy: 13.034,
    r: 0.168
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1C75BB",
    cx: 14.588,
    cy: 13.005,
    r: 0.168
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector4);
export default __webpack_public_path__ + "static/media/vector4.39fc4635c6543b05aadd5f292c4b3f3e.svg";
export { ForwardRef as ReactComponent };